import React from 'react';
import { ArrowRight, Sparkles, TrendingUp } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

export const HeroNew = () => {
  const { t, direction } = useLanguage();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="accueil" className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-b from-blue-50 to-white">
      {/* Background Image - Using PROVIDED hero image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_hazard-guard-1/artifacts/fhm8ed00_2222.png"
          alt="Olion Products"
          className="w-full h-full object-cover opacity-100"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/50 via-blue-50/40 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pt-20" dir="ltr">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content - Always on left even in Arabic */}
          <div className="space-y-8 text-left" dir={direction}>
            <div className="inline-flex items-center gap-2 bg-blue-100/80 backdrop-blur-sm px-4 py-2 rounded-full border border-blue-200">
              <Sparkles className="w-5 h-5 text-blue-600" />
              <span className="text-sm font-medium text-blue-800">{t('hero.subtitle')}</span>
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight text-blue-900">
              Olion
            </h1>

            <p className="text-3xl font-semibold text-orange-500">
              {t('hero.slogan')}
            </p>

            <p className="text-lg sm:text-xl text-gray-700 leading-relaxed max-w-2xl">
              {t('hero.description')}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                onClick={() => scrollToSection('produits')}
                className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-8 py-6 rounded-full text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 group"
              >
                {t('hero.cta1')}
                <ArrowRight className={`${direction === 'rtl' ? 'mr-2 rotate-180' : 'ml-2'} w-5 h-5 group-hover:translate-x-1 transition-transform`} />
              </Button>
              
              <Button
                onClick={() => scrollToSection('partenaires')}
                variant="outline"
                className="border-2 border-blue-600 text-blue-800 bg-white/80 hover:bg-blue-600 hover:text-white px-8 py-6 rounded-full text-lg font-semibold backdrop-blur-sm transition-all duration-300 transform hover:scale-105"
              >
                {t('hero.cta2')}
              </Button>
            </div>

            {/* Stats - Always left aligned */}
            <div className="grid grid-cols-2 gap-8 pt-8">
              <div className="text-center bg-white/60 backdrop-blur-sm rounded-2xl p-6 shadow-lg">
                <div className="text-5xl font-bold text-blue-800">70+</div>
                <div className="text-base text-gray-700 mt-2">{t('hero.stats.products')}</div>
              </div>
              <div className="text-center bg-white/60 backdrop-blur-sm rounded-2xl p-6 shadow-lg">
                <div className="text-5xl font-bold text-blue-800">200+</div>
                <div className="text-base text-gray-700 mt-2">{t('hero.stats.pointsOfSale')}</div>
              </div>
            </div>
          </div>

          {/* Right side - Let background show */}
          <div className="hidden lg:block"></div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-blue-400 rounded-full flex justify-center pt-2">
          <div className="w-1.5 h-3 bg-blue-600 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};
